import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { categoryApiSlice } from "../../features/category/categoryApiSlice";
import socketSetup from "../../socket-io/socket-io";
import { packageApiSlice } from "../../features/package/packageApiSlice";
import { clientApiSlice } from "../../features/client/clientApiSlice";
import { orderApiSlice } from "../../features/order/orderApiSlice";

export const useClientSocket = () => {
    const dispatch = useDispatch();

    const invalidateClient = useCallback(() => {
        dispatch(
            clientApiSlice.util.invalidateTags([
                { type: "Client", id: "LIST" },
            ])
        );
    }, [dispatch]);

    const invalidateOrder = useCallback(() => {
        dispatch(
            orderApiSlice.util.invalidateTags([
                { type: "Client", id: "LIST" },
            ])
        );
    }, [dispatch]);

    useEffect(() => {
        if (!socketSetup) return;

        socketSetup.on("registerClient", invalidateClient); 
        socketSetup.on("updateClient", invalidateClient); 
        socketSetup.on("generatePin", invalidateClient); 
        socketSetup.on("addSpecialPackage", invalidateClient); 
        
        socketSetup.on("checkout", invalidateOrder); 

        return () => {
            socketSetup.off("registerClient", invalidateClient); 
            socketSetup.off("updateClient", invalidateClient); 
            socketSetup.off("generatePin", invalidateClient); 
            socketSetup.off("addSpecialPackage", invalidateClient); 

            socketSetup.off("checkout", invalidateOrder); 
        };
    }, [invalidateClient, invalidateOrder]);
}